import { Pipe, PipeTransform } from '@angular/core';

import { ConfigService } from '../../../../core';
import { ConfigEmpresa, createNomeSecundarioCliente } from '../../../configuracoes/app/empresa';

@Pipe({
    name: 'clienteNomeSecundario'
})
/** Pipe utilizado para exibir o nome secundário do cliente conforme forma de identificação configurada pela empresa */
export class ClienteNomeSecundarioPipe implements PipeTransform {
    configEmpresa: ConfigEmpresa;

    constructor(private configService: ConfigService) {
        this.configEmpresa = this.configService.getEmpresa();
    }

    /** Retorna o nome secundário do cliente conforme a identificação do cliente pela empresa selecionada na configuração da Empresa */
    transform(nome: string, nomeFantasia: string, codigoIntegracaoErp: string = null): string {
        return createNomeSecundarioCliente(this.configEmpresa.identificacaoCliente, nome, nomeFantasia, codigoIntegracaoErp);
    }
}
